import * as firebase from 'firebase/app';
import 'firebase/firestore';
import * as _ from "lodash";
import * as React from "react";

export interface IFireInputProps { private: boolean }
//  interface IState { inputValue: string }

// State is never set so we use the '{}' type.

export class FireInput extends React.Component<IFireInputProps, any> {

    private static db: firebase.firestore.Firestore;


    constructor(props: IFireInputProps) {
        super(props);
        this.state = {
            currentComment: [],
            inputValue: '',
            isPrivate: props.private
        };
        this.SendMessage = this.SendMessage.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);

        if (_.isEmpty(FireInput.db)) {
            firebase.initializeApp({
                apiKey: 'AIzaSyDOFyTPqkbjp9y4YUW-8XlRrQE7hAWdoQ0',
                authDomain: 'wingtakwong.com',
                projectId: 'wingtak-wong'
            });
            FireInput.db = firebase.firestore();
            const settings = {/* your settings... */ timestampsInSnapshots: true };
            FireInput.db.settings(settings);
        }
    }

    // tslint:disable-next-line:no-empty
    public componentDidMount() {
        this.FetchComments();
    }

    // tslint:disable-next-line:no-empty
    public componentWillUnmount() {

    }

    public FetchComments() {
        if (!this.state.isPrivate) {
            const docRef = FireInput.db.collection("publicComment");

            docRef.orderBy("time","desc").limit(10).get()
                .then((doc: firebase.firestore.QuerySnapshot) => {
                    if (!doc.empty) {
                        const newComments: any[] = [""];
                        doc.forEach((x) => {

                            const message = x.data().message;
                            newComments.push(<p>{message}</p>);
                        });
                        this.setState({ currentComment: <div>{newComments}</div> });
                    } else {
                        // tslint:disable-next-line:no-console
                        console.log("No such document!");
                    }
                }).catch((error: any) => {
                    // tslint:disable-next-line:no-console
                    console.log("Error getting document:", error);
                });
        }
    }

    public SendMessage() {
        if (this.state.inputValue) {
            const key = (this.state.isPrivate ? "private" : "public") + "Comment";
            firebase.firestore().collection(key).add({
                message: this.state.inputValue,
                time: new Date()
            });
            this.setState({ inputValue: '' })
        }
        this.FetchComments();
    }

    public handleChange(event: any) {
        this.setState({ inputValue: event.target.value });
    }

    public handleKeyPress(event: any) {
        if (event.key === 'Enter') {
            this.SendMessage();
        }
    }

    public render() {
        const isPrivate = this.state.isPrivate;
        const comments = this.state.currentComment;

        return (
            <div className="container border">
                <p>{isPrivate ? 'private' : 'public'} comment box</p>
                {isPrivate && <p>J'accepte aussi les commentaires négatifs</p>}
                <div className="row">
                    <input className="form-control col-10" type="text" name="FirstName"
                        value={this.state.inputValue}
                        onChange={this.handleChange}
                        onKeyPress={this.handleKeyPress} />
                    <button className="btn btn-danger col-2" onClick={this.SendMessage}>Submit</button>
                </div>                
                {!isPrivate &&
                    <div>{comments}</div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Items/FireInput.tsx